// extracted by mini-css-extract-plugin
export default {"singleProductGroup":"SingleProductGroup_singleProductGroup__hPBme","active":"SingleProductGroup_active__t7GJ8","checkBoxSize":"SingleProductGroup_checkBoxSize__zOPvr"};